import { cn } from '@/shared/lib/utils';
import * as React from 'react';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				'border-gray-05  focus:outline-none bg-background-primary placeholder:text-label-tertiary text-label-primary h-12 w-full rounded-lg border px-4 py-3 text-base leading-6 font-normal',
				className
			)}
			{...props}
		/>
	);
}

export { Input };
